module.exports = __webpack_public_path__ + "static/media/rendimiento esperado-gris_old.641e23e8.svg";